<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('bill.immediate_share') }}</div>
    <div slot="body">
      <!-- <dialog-selected-tips :name="$t('bill.bill_sharing_policy')" :count="params.data.length" :action="$t('bill.bind_to_account')" /> -->
      <!-- <dialog-table :data="params.data" :columns="params.columns.slice(0, 3)" /> -->
      <a-form-model
        ref="form"
        class="mt-3"
        :model="form"
        :rules="rules"
        v-bind="formItemLayout">
        <!-- <a-form-model-item :label="$t('res.cloudaccount')" prop="account_id">
          <base-select
            v-model="form.account_id"
            :options="accountOpts"
            :disabled-items="getDisabledAccounts()"
            :select-props="{placeholder: $t('common.tips.select', [$t('res.cloudaccount')])}" />
        </a-form-model-item> -->
        <a-form-model-item :label="$t('bill.share_month')" prop="month">
          <a-month-picker class="w-100" v-model="form.month" valueFormat="YYYYMM" format="YYYY-MM" :placeholder="$t('common.tips.select', [$t('bill.share_month')])" :disabled-date="disabledDate" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'BillSharingShareDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    // const { accounts = [] } = this.params.data[0]
    // const initList = []
    // accounts.map(item => {
    //   initList.push({
    //     name: item.account,
    //     id: item.account_id,
    //     disabled: this.$moment(item.date + '') > this.$moment(),
    //   })
    // })
    return {
      loading: false,
      form: {
        month: this.$moment().subtract(1, 'month').format('YYYYMM'),
      },
      rules: {
        // account_id: [{ required: true, message: this.$t('common.tips.select', [this.$t('res.cloudaccount')]) }],
        month: [{ required: true, message: this.$t('common.tips.select', [this.$t('bill.share_month')]) }],
      },
      // accountOpts: initList,
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
    }
  },
  created () {
    this.$bM = new this.$Manager('billtasks/submit')
    // this.fetchAccount()
  },
  methods: {
    disabledDate (date) {
      // 不可选下月之后的时间
      if (date.startOf('month') > this.$moment().subtract(1, 'month').endOf('month')) {
        return true
      }
      return false
    },
    // getDisabledAccounts () {
    //   const ret = []
    //   this.accountOpts.map(item => {
    //     if (item.disabled) {
    //       ret.push(item.id)
    //     }
    //   })
    //   return ret
    // },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid, err) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(err)
          }
        })
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const validate = await this.validateForm()
        if (!validate) return
        await this.$bM.create({
          data: {
            account_id: this.params.account_id,
            month: parseInt(this.form.month),
            task_type: this.params.task_type || 'project_sharing',
          },
        })
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
